import { sortBy } from 'lodash';
import { getTagCategory, getTagTitle } from '@repo/ui-components/dept/utils';
import { getPricePoints } from './getPricePoints';

const getActiveFilters = ({
  bothPetTypesCollection,
  location,
  onShopAllPage,
  products,
  priceFormatter,
  tt,
}) => {
  let allFilters = [];
  const searchParams = new URLSearchParams(location.search);

  if (!onShopAllPage) {
    const filterTags = products
      .filter(({ shopifyProduct }) => !!shopifyProduct)
      .flatMap(p => p.shopifyProduct.tags.filter(f => f.startsWith('+')));

    const tagFilters = filterTags.reduce((fs, tag) => {
      const f = getTagCategory(tag);
      const translatedTitle = getTagTitle(tt(() => `productTagsList.${tag}`));

      if (!translatedTitle) {
        return fs;
      }

      const tagProps = {
        title: translatedTitle,
        tag,
        other: {
          f,
        },
        active: !!searchParams.get(f)?.split(',').includes(tag),
      };

      if (fs[f]) {
        if (!fs[f].some(t => t.title === translatedTitle)) fs[f].push(tagProps);
      } else {
        // eslint-disable-next-line no-param-reassign
        fs[f] = [tagProps];
      }
      return fs;
    }, {});

    allFilters = [
      ...sortBy(
        Object.entries(tagFilters).map(([group, filters]) => ({
          group,
          groupTitle: getTagCategory(
            tt(() => `productTagsList.${filters[0].tag}`)
          ),
          filters,
        })),
        ['groupTitle']
      ),
    ];
  }

  if (products.length > 5) {
    const priceFilters = getPricePoints(products, priceFormatter).map(pp => ({
      ...pp,
      active: !!searchParams.get('Price')?.includes(pp.point),
      type: 'price',
    }));
    allFilters.unshift({
      group: 'Price',
      groupTitle: tt(s => s.productsPage.priceTitle),
      filters: priceFilters,
    });
  }

  if (bothPetTypesCollection) {
    const petFilters = ['Dog', 'Cat'].map(pet => ({
      title: tt(s => s.productsPage[`${pet.toLowerCase()}Title`]),
      tag: pet,
      active: !!searchParams.get('Pet Type')?.includes(pet),
      type: 'pet',
    }));
    allFilters.unshift({
      group: 'Pet Type',
      groupTitle: tt(s => s.productsPage.petTypeTitle),
      filters: petFilters,
    });
  }
  return allFilters;
};

export default getActiveFilters;
